import { render, staticRenderFns } from "./bbsCard.vue?vue&type=template&id=8495ad96&scoped=true&"
import script from "./bbsCard.vue?vue&type=script&lang=js&"
export * from "./bbsCard.vue?vue&type=script&lang=js&"
import style0 from "./bbsCard.vue?vue&type=style&index=0&id=8495ad96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495ad96",
  null
  
)

export default component.exports